<template>
<BootstrapDialog title="修改题库" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-8 col-sm-offset-2">
		            <form role="form">
		                <!--题库名称-->
		                <div class="form-group">
		                    <label><span class="required" style="margin-right: 5px;color: red">*</span>题库名称</label>
		                    <input type="text" v-model="model.tkmc" name="txmc" v-validate="{required:true,max:50}" data-vv-as="题库名称 " class="form-control" placeholder=""/>
		                    <span class="error_validate_msg"><em>{{ errors.first('txmc') }}</em></span>
		                </div>
		                <!--题库课程-->
		                <div class="form-group">
		                    <label><span class="required" style="margin-right: 5px;color: red">*</span>题库课程</label>
							<BootstrapCombobox :data="tkkcList" data-vv-as="课程" name="kcId"  text-field="kcmc" value-field="id" v-model="model.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)" placeholder="-课程筛选-"></BootstrapCombobox>
		                    <span class="error_validate_msg"><em>{{ errors.first('kcId') }}</em></span>
		                </div>
		                <!--题库图标-->
		                <div class="form-group">
		                    <label>题库图标</label>
		                    <image-upload v-model="model.tktb"></image-upload>
		                </div>
		                <!--状态-->
		                <div class="form-group">
		                    <label><span class="required" style="margin-right: 5px;color: red">*</span>状态</label>
		                    <select v-model="model.zt" name="zt" v-validate="{required:true,max:50}" data-vv-as="状态" class="form-control ">
		                        <option value="">-请选择-</option>
		                        <option v-for="zt in ztList" :key="zt.value" :value="zt.value">{{zt.text}}</option>
		                    </select>
		                    <span class="error_validate_msg"><em>{{ errors.first('zt') }}</em></span>
		                </div>
		                <!--题库说明-->
		                <div class="form-group">
		                    <label><span class="required" style="margin-right: 5px;color: red">*</span>题库说明</label>
		                    <input type="text" name="tksm" v-model="model.tksm" v-validate="{required:true,max:50}" data-vv-as="题库说明"  class="form-control" placeholder=""/>
		                    <span class="error_validate_msg"><em>{{ errors.first('tksm') }}</em></span>
		                </div>
		            </form>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-primary" type="button" @click="save()">保存</button>
			<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 题库列表修改
     */
    export default {
        name:'QuesBankEdit',
        components:{
        },
        data:function(){
            return {
                model:{
                    id:'',
                    tkmc:'',
                    kcId:'',
                    tktb:'',
                    zt:'',
                    tksm:'',
                },
                tkkcList:[],//课程下拉
                ztList: [],//状态
            }
        },
        created:function(){
            this.ztList = [{value: 'OK', text: '开放'}, {value: 'BLOCK', text: '关闭'}]//状态
        },
        methods:{
			reset:function(){
				this.model = {
				    id:'',
				    tkmc:'',
				    kcId:'',
				    tktb:'',
				    zt:'',
				    tksm:''
				};
				this.tkkcList = [];//课程下拉
			},
			async open(params){
				this.model.id = params.id;
				let res =await this.$http.post('/htgl/zktk/tk/hq',{id:this.model.id});
				if(res.data){
					this.model.tkmc = res.data.tkmc;
					this.model.kcId = res.data.kcId;
					this.model.tktb = res.data.tktb;
					this.model.zt = res.data.zt;
					this.model.tksm = res.data.tksm;
				}
				res = await this.$http.post('/htgl/zktk/tk/hqkc');
				if(res.data){
					this.tkkcList = res.data;
				}
				this.$nextTick(()=>{
					this.$refs.dialog.open();
				});
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            //课程下拉
            gettkkcList:function(){
                this.$http.post('/htgl/zktk/tk/hqkc').then(res=>{
                    this.tkkcList = res.data;
                });
            },
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/zktk/tk/xg',this.model).then(res=>{
                            if(res.data==true){
								this.$success('操作成功',()=>{
									this.close();
									this.$parent.load();//刷新列表
								});
                            }
                        });
                    }
                });
            }
        }

    }
</script>